import { PasswordResetView } from '@/views';

const redirectIfSignedIn = (route, query) => function redirect() {
  if (this.$store != null && this.$store.getters['session/isSignedIn']) {
    this.$router.push({ path: route, query });
  }
};

const routes = {
  privatePaths: [],
  publicPaths: [
    {
      path: 'passwordreset',
      name: 'passwordreset',
      component: PasswordResetView,
      props: () => ({
        onMounted: redirectIfSignedIn('/'),
      }),
    },
  ],
};
export default routes;
